var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FFE3BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.2666C20 33.2976 20.8357 34.1333 21.8667 34.1333C22.8976 34.1333 23.7333 33.2976 23.7333 32.2666C23.7333 32.1053 23.7065 31.9516 23.668 31.8022L26.0963 27.552L30.3476 29.9814C30.5724 30.7602 31.2823 31.3333 32.1333 31.3333C33.1643 31.3333 34 30.4976 34 29.4666C34 29.2972 33.9701 29.1361 33.9279 28.98L37.3359 22.8458C38.1037 22.6144 38.6667 21.91 38.6667 21.0666C38.6667 20.0357 37.8309 19.2 36.8 19.2C35.7691 19.2 34.9333 20.0357 34.9333 21.0666C34.9333 21.2354 34.9629 21.396 35.0049 21.5514L31.6224 27.6393L27.3855 25.2177C27.1607 24.4393 26.4508 23.8666 25.6 23.8666C24.5691 23.8666 23.7333 24.7024 23.7333 25.7333C23.7333 25.8949 23.7604 26.049 23.7989 26.1985L21.3523 30.4808C20.5733 30.7053 20 31.4154 20 32.2666Z",
    fill: "#573E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 35.9999H17.3333V18.6666C17.3333 17.9297 16.7369 17.3333 16 17.3333C15.263 17.3333 14.6666 17.9297 14.6666 18.6666V37.3333C14.6666 38.0702 15.263 38.6666 16 38.6666H40C40.7369 38.6666 41.3333 38.0702 41.3333 37.3333C41.3333 36.5963 40.7369 35.9999 40 35.9999Z",
    fill: "#573E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.19e2c3150037c4d2bbb5420da547cab3.svg";
export { ForwardRef as ReactComponent };